import React from 'react';
import styles from '../../../assets/styles/globals.scss';

const directionPropToRotationDegrees = {
  'up': 0,
  'right': 90,
  'down': 180,
  'left': 270,
};

export default function ArrowIcon(props) {
  const color = props.fillColor || styles.lightElement;
  const rotationDegrees = directionPropToRotationDegrees[props.direction] || 0;
  const rotationStyle = { transform: 'rotate('+rotationDegrees+'deg)' };
  return (
    <svg style={rotationStyle} width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>Triangle</title>
        <desc>Created with Sketch.</desc>
        <g id="Staging" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
            <g id="User-Dashboard---With-Summary-Info" transform="translate(-140.000000, -472.000000)" fill={color} fillRule="nonzero">
                <g id="Group-5" transform="translate(12.000000, 412.000000)">
                    <polygon id="Triangle" points="135 60 142 74 128 74"></polygon>
                </g>
            </g>
        </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Iconoclast/ArrowIcon/index.js